import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';
import styles from './index.css';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import { sessionStroe } from '../../utils/sessionStorage';

class SingleImg extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        countNum: PropTypes.number,
        liveNum: PropTypes.number,
    };

    state = {
        isHorizontalScreen: false,
        isSelfRead: false,
    };

    componentDidMount() {
        this.horizontalStyle();
    }

    horizontalStyle = () => {
        const pageWidth = document.documentElement.clientWidth;
        const pageHeight = document.documentElement.clientHeight;

        if (pageWidth > pageHeight) {
            this.setState({
                isHorizontalScreen: true,
            });
        } else {
            this.setState({
                isHorizontalScreen: false,
            });
        }
        window.addEventListener(
            'orientationchange',
            event => {
                if (event.currentTarget.orientation !== 0) {
                    this.setState({
                        isHorizontalScreen: true,
                    });
                } else {
                    this.setState({
                        isHorizontalScreen: false,
                    });
                }
            },
            false,
        );
    };

    formatVideoDuration = duration => {
        let second = parseInt(duration);
        let minute = 0;
        let hour = 0;
        let formatedDuration = '';

        if (second >= 60) {
            minute = parseInt(second / 60);
            second = parseInt(second % 60);
            if (minute >= 60) {
                hour = parseInt(minute / 60);
                minute = parseInt(minute % 60);
            }
        }

        minute = minute < 10 ? `0${minute}` : minute;
        second = second < 10 ? `0${second}` : second;
        hour = hour < 10 ? `0${hour}` : hour;

        if (parseInt(duration) < 60) {
            formatedDuration = `00:${second}`;
        }

        if (minute > 0) {
            formatedDuration = `${minute}:${second}`;
        }

        if (hour > 0) {
            formatedDuration = `${hour}:${minute}:${second}`;
        }

        return formatedDuration;
    };

    alreadHandle = url => {
        const readUrl = sessionStroe.getSession('readUrl');

        sessionStroe.setSession('readUrl', `${readUrl},${url}`);
        this.setState({
            isSelfRead: true,
        });
        location.href = url;
    };
    render() {
        /**
         * 组件分发数据
         */
        const { content, liveNum, countNum } = this.props;
        const { isHorizontalScreen, isSelfRead } = this.state;
        const {
            title = '',
            ESsourceAlias = '',
            thumbnails = [],
            thumbnail = '',
            type = 'article',
            duration = '',
            slideCount = '',
            base62Id = '',
        } = content;
        const loadlazyImag = 'https://x0.ifengimg.com/cmpp/2020/0513/4414e9f1d3521d1size0_w45_h30.png';
        const thumbnailImg =
            (thumbnail && formatImage(thumbnail, 450, 300)) ||
            (thumbnails &&
                thumbnails.image &&
                thumbnails.image[0] &&
                thumbnails.image[0].url &&
                formatImage(thumbnails.image[0].url, 450, 300)) ||
            loadlazyImag;
        const time = duration ? this.formatVideoDuration(duration) : '';
        // const loadlazyImag = 'https://x0.ifengimg.com/cmpp/2020/0210/e5d6ab7fb8f86dcsize1_w450_h300.png';
        const urlVal = `https://h5.ifeng.com/c/huawei/${base62Id}?appid=hwbrowser&ch=ref_hwllq_dl1`;
        const isLastFeed = !!(liveNum && countNum && liveNum === countNum);
        const isRead =
            sessionStroe
                .getSession('readUrl')
                .toString()
                .includes(urlVal) || isSelfRead;

        return (
            <Fragment>
                {base62Id && (
                    <a
                        className={`${styles.topicModule_feed_link} ${isRead ? styles.active : ''}`}
                        onClick={this.alreadHandle.bind(this, urlVal)}>
                        <div
                            className={`${styles.topicModule_feed} ${
                                isHorizontalScreen ? styles.horizontal_feed : ''
                            } ${isLastFeed ? styles.noBottomLine : ''}`}>
                            <div className={styles.topicModule_feedleft}>
                                <h2 className={styles.topicModule_feedtxt}>{title}</h2>
                                <div className={styles.topicModule_feedmark}>
                                    <span className={styles.topicModule_feed_source}>{ESsourceAlias}</span>
                                </div>
                            </div>
                            <div className={styles.topicModule_feedimg}>
                                <LazyImg
                                    className={styles.topicModule_feedimg_box}
                                    placeholder={loadlazyImag}
                                    src={thumbnailImg}
                                />
                                {type === 'video' &&
                                    time && <span className={styles.topicModule_feedimg_mark}>{time}</span>}
                                {type === 'slide' &&
                                    slideCount && (
                                        <span className={styles.topicModule_feedimg_slideNum}>{slideCount}图</span>
                                    )}
                            </div>
                        </div>
                    </a>
                )}
            </Fragment>
        );
    }
}

export default errorBoundary(SingleImg);
